import { Box, HStack } from "@chakra-ui/react";
import { useState } from "react";
import { Star } from "lucide-react";

type Props = {
  value: number;
  onChange?: (value: number) => void;
  size?: number;
  color?: string;
};

const StarRating = ({
  value,
  onChange,
  size = 24,
  color = "#FACC15",
}: Props): JSX.Element => {
  const [hoverValue, setHoverValue] = useState<number | null>(null);

  const handleClick = (index: number, isHalf: boolean) => {
    if (!onChange) return;
    onChange(isHalf ? index + 0.5 : index + 1);
  };

  const handleMouseMove = (e: React.MouseEvent, index: number) => {
    const { left, width } = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - left;
    const isHalf = x < width / 2;
    setHoverValue(isHalf ? index + 0.5 : index + 1);
  };

  const handleMouseLeave = () => {
    setHoverValue(null);
  };

  return (
    <HStack gap={2} onMouseLeave={handleMouseLeave} justifyContent="center">
      {[0, 1, 2, 3, 4].map((index) => {
        const currentValue = hoverValue ?? value;
        const isFull = currentValue >= index + 1;
        const isHalf = currentValue >= index + 0.5 && currentValue < index + 1;

        return (
          <Box
            key={index}
            position="relative"
            cursor={onChange ? "pointer" : "default"}
            onMouseMove={(e) => handleMouseMove(e, index)}
            onClick={(e) => {
              const { left, width } = e.currentTarget.getBoundingClientRect();
              const x = e.clientX - left;
              const isHalfClick = x < width / 2;
              handleClick(index, isHalfClick);
            }}
          >
            <Star size={size} color="#D1D5DB" />

            {isFull || isHalf ? (
              <Box
                position="absolute"
                top={0}
                left={0}
                overflow="hidden"
                clipPath={isHalf ? "inset(0 50% 0 0)" : "none"}
              >
                <Star size={size} color={color} fill={color} />
              </Box>
            ) : null}
          </Box>
        );
      })}
    </HStack>
  );
};

export default StarRating;
